export default __webpack_public_path__ + "static/media/close_fill.2d723288.svg";